// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Стиль для всего уведомления */
.alert {
    position: fixed;
    opacity: 0.7;
    top: 20px; /* Расположение сверху */
    /* left: 80%; */
    /* transform: translateX(-50%); */
    padding: 15px;
    background-color: red; /* Красный фон */
    color: white;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 20%;
    max-width: 500px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 9999;
    font-size: 16px;
    right: 5%;
  }
  .alert span {
    white-space: nowrap; /* Запрещаем переносу текста */
    overflow: hidden; /* Обрезаем текст */
    text-overflow: ellipsis; /* Добавляем многоточие, если текст не помещается */
    flex-grow: 1; /* Чтобы span занимал все доступное пространство */
  }
  
  .close-btn {
    background: none;
    border: none;
    color: white;
    font-size: 18px;
    cursor: pointer;
    padding: 0;
    margin-left: 15px;
    flex-shrink: 0; /* Кнопка всегда будет видимой и не будет сжиматься */
  }
  .alert.success {
    background-color: green; /* Зеленый фон для успешных уведомлений */
  }
  
  .alert.error {
    background-color: red; /* Красный фон для ошибок */
  }
  
  `, "",{"version":3,"sources":["webpack://./src/components/Alert/Alert.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;IACI,eAAe;IACf,YAAY;IACZ,SAAS,EAAE,wBAAwB;IACnC,eAAe;IACf,iCAAiC;IACjC,aAAa;IACb,qBAAqB,EAAE,gBAAgB;IACvC,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,wCAAwC;IACxC,aAAa;IACb,eAAe;IACf,SAAS;EACX;EACA;IACE,mBAAmB,EAAE,8BAA8B;IACnD,gBAAgB,EAAE,mBAAmB;IACrC,uBAAuB,EAAE,mDAAmD;IAC5E,YAAY,EAAE,kDAAkD;EAClE;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;IACf,UAAU;IACV,iBAAiB;IACjB,cAAc,EAAE,qDAAqD;EACvE;EACA;IACE,uBAAuB,EAAE,yCAAyC;EACpE;;EAEA;IACE,qBAAqB,EAAE,2BAA2B;EACpD","sourcesContent":["/* Стиль для всего уведомления */\n.alert {\n    position: fixed;\n    opacity: 0.7;\n    top: 20px; /* Расположение сверху */\n    /* left: 80%; */\n    /* transform: translateX(-50%); */\n    padding: 15px;\n    background-color: red; /* Красный фон */\n    color: white;\n    border-radius: 5px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 20%;\n    max-width: 500px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    z-index: 9999;\n    font-size: 16px;\n    right: 5%;\n  }\n  .alert span {\n    white-space: nowrap; /* Запрещаем переносу текста */\n    overflow: hidden; /* Обрезаем текст */\n    text-overflow: ellipsis; /* Добавляем многоточие, если текст не помещается */\n    flex-grow: 1; /* Чтобы span занимал все доступное пространство */\n  }\n  \n  .close-btn {\n    background: none;\n    border: none;\n    color: white;\n    font-size: 18px;\n    cursor: pointer;\n    padding: 0;\n    margin-left: 15px;\n    flex-shrink: 0; /* Кнопка всегда будет видимой и не будет сжиматься */\n  }\n  .alert.success {\n    background-color: green; /* Зеленый фон для успешных уведомлений */\n  }\n  \n  .alert.error {\n    background-color: red; /* Красный фон для ошибок */\n  }\n  \n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
